import { inject, Injectable } from '@angular/core';

import { ScreenOrientations } from '../models';
import { NavigationService } from './navigation.service';

/**
 * @deprecated use store
 */
@Injectable({ providedIn: 'root' })
export class AppService {
  /**
   * @deprecated use {@link ClientManagementSelectors.getCurrentClientId} instead
   */
  get currentClient() {
    return this.navigationService.getCurrentClientId();
  }

  get isInitailizedAppSubscription() {
    return this._isInitailizedAppSubscription;
  }

  set isInitailizedAppSubscription(val: boolean) {
    this._isInitailizedAppSubscription = val;
  }

  get managingClientId() {
    return this._managingClientId;
  }

  set managingClientId(val) {
    this._managingClientId = val;
  }

  get screenOrientation() {
    return this._screenOrientation;
  }

  set screenOrientation(val) {
    this._screenOrientation = val;
  }

  private _managingClientId!: string;
  private _isInitailizedAppSubscription = false;
  private _screenOrientation = ScreenOrientations.PORTRAIT;

  private navigationService = inject(NavigationService);
}
